/**
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
**/
window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.aliasManagementBehavior = {
    properties: {
        submitObject: {
            type: Object,
            notify: true
        }
    },
    /*event to set post api parameters*/
    setPostParameters: function () {
        var method, url;
        if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
            this.authMethods = [];
            this.header = [];
        } else {
            if (this.authenticationValidation(this.authMethods)) return;
            if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

            if (this.authMethods && this.authMethods.length == 2) {
                this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
                this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
            }
        }
        if (this.selectedMoreOption == getLabel("l_changeAccount")) {
            this.submitObject = {
                "accountId": this.selectedFromAccount.accountId,
                "aliasName": this.selectedAliasDeatils.aliasName,
                "aliasType": this.selectedAliasDeatils.aliasType.cmCode,
                "alias": this.selectedAliasDeatils.alias,
                "currentAccountId": this.selectedAliasDeatils.accountId
            }
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-account-change-requests";
        } else if (this.selectedMoreOption == getLabel("l_delete")) {
            this.submitObject = {
                "accountId": this.selectedAliasDeatils.accountId,
                "aliasType": this.selectedAliasDeatils.aliasType.cmCode,
                "alias": this.selectedAliasDeatils.alias,
            }
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-deregister-requests";
        }
        else if (this.selectedMoreOption == getLabel("l_transfer")) {
            this.submitObject = {
                "accountId": this.selectedAliasDeatils.accountId,
                "aliasType": this.selectedAliasDeatils.aliasType.cmCode,
                "alias": this.selectedAliasDeatils.alias,
            }
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-transfer-requests";
        }
        else if (this.selectedMoreOption == getLabel("l_inactivate")) {
            console.log(this.reasonCode);
            this.submitObject = {
                "accountId": this.selectedAliasDeatils.accountId,
                "aliasType": this.selectedAliasDeatils.aliasType.cmCode,
                "alias": this.selectedAliasDeatils.alias,
                "reasonCode": this.reasonCode,
            }
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-lock-requests";
        }
        else if (this.selectedMoreOption == getLabel("l_activateAlias")) {
            this.submitObject = {
                "accountId": this.selectedAliasDeatils.accountId,
                "aliasType": this.selectedAliasDeatils.aliasType.cmCode,
                "alias": this.selectedAliasDeatils.alias,
                "reasonCode": this.reasonCode,
            }
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-unlock-requests";
        }
        else if (this.selectedMoreOption === "REGISTER_ALIAS") {
            this.submitObject = this.registerAliasObject;
            var body = this.submitObject;
            url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/alias-register-requests";
        }
        method = 'post';
        this.submitDetails(url, method, body, this.header);


    },

    /*event to validate alias registration object*/
    validateRegisteredAlias: function () {
        var isValid = true;
        if (_.isEmpty(this.registerAliasObject.aliasType)) {
            isValid = false;
            this.$$('#RegisterAliasIDType').invalid = true;
            this.$$('#RegisterAliasIDType').errorMessage = "m_reqSelectAliasType";
            return isValid;
        }
        if (_.isEmpty(this.registerAliasObject.alias)) {
            isValid = false;
            this.$$('#RegisterAliasID').invalid = true;
            this.$$('#RegisterAliasID').errorMessage = "m_reqEnterAlias";
            return isValid;
        }
        else {
            if (this.disableAliasAvailability) {
                isValid = false
                return isValid;
            }
        }
        if (!this.isAliasAvailable) {
            if (this.isAliasNotAvailable) {
                isValid = false;
                this.fire('oe-show-error', {
                    message: getLabel('m_validAliasId')
                });
                return isValid;
            }
            isValid = false;
            this.fire('oe-show-error', {
                message: getLabel('m_verifyAliasId')
            });
            return isValid;
        }
        if (_.isEmpty(this.registerAliasObject.accountId)) {
            isValid = false;
            this.fire('oe-show-error', {
                message: getLabel('m_selectAccountNumber')
            });
            return isValid;
        }
        if (_.isEmpty(this.registerAliasObject.tncFlag)) {
            isValid = false;
            this.fire('oe-show-error', {
                message: getLabel('m_reqAcceptTermsAndConditions')
            });
            return isValid;
        }
        return isValid;
    },

    /*method to sort alias list response*/
    priorityBasedSort: function (aliasList) {
        var sortedList = [];
        var sortOrder = [{
            status: "A",
            aliasType: "PHONE"
        }, {
            status: "A",
            aliasType: "EMAIL"
        }, {
            status: "A",
            aliasType: "BNUM"
        }, {
            status: "T",
            aliasType: "PHONE"
        }, {
            status: "T",
            aliasType: "EMAIL"
        }, {
            status: "T",
            aliasType: "BNUM"
        }, {
            status: "I",
            aliasType: "PHONE"
        }, {
            status: "I",
            aliasType: "EMAIL"
        }, {
            status: "I",
            aliasType: "BNUM"
        }, {
            status: "L",
            aliasType: "PHONE"
        }, {
            status: "L",
            aliasType: "EMAIL"
        }, {
            status: "L",
            aliasType: "BNUM"
        }, {
            status: "D",
            aliasType: "PHONE"
        }, {
            status: "D",
            aliasType: "EMAIL"
        }, {
            status: "D",
            aliasType: "BNUM"
        }];
        sortOrder.forEach(function (orderItem) {
            for (var i = 0; i < aliasList.length; i++) {
                if (aliasList[i].status.cmCode === orderItem.status && aliasList[i].aliasType.cmCode === orderItem.aliasType) {
                    sortedList.push(aliasList[i]);
                }
            }
        });
        return sortedList;
    }
};